import {
  css
} from 'lit';

/* MUST BE KEPT IN SYNC with ./src/css/variants/progress-indicator.css */

export const ProgressIndicatorStyle = css`
.lds-progress-indicator {
  position: relative;
  display: inline-block;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.lds-progress-indicator-circle-base {
  fill: var(--lds-color-progress-indicator-circle-base-fill);
  stroke: var(--lds-color-progress-indicator-circle-base);
}

.lds-progress-indicator-circle-progress {
  transition: stroke-dashoffset 300ms;
  fill: var(--lds-color-progress-indicator-circle-fill);
  stroke: var(--lds-color-progress-indicator-circle-progress);
}
/* Allows the color of the current progress stroke to change with every 10% change in the progress, if desired */
.lds-progress-indicator.progress-incomplete.progress-0 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-0);
  stroke: var(--lds-color-progress-indicator-circle-progress-0);
}
.lds-progress-indicator.progress-incomplete.progress-10 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-10);
  stroke: var(--lds-color-progress-indicator-circle-progress-10);
}
.lds-progress-indicator.progress-incomplete.progress-20 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-20);
  stroke: var(--lds-color-progress-indicator-circle-progress-20);
}
.lds-progress-indicator.progress-incomplete.progress-30 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-30);
  stroke: var(--lds-color-progress-indicator-circle-progress-30);
}
.lds-progress-indicator.progress-incomplete.progress-40 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-40);
  stroke: var(--lds-color-progress-indicator-circle-progress-40);
}
.lds-progress-indicator.progress-incomplete.progress-50 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-50);
  stroke: var(--lds-color-progress-indicator-circle-progress-50);
}
.lds-progress-indicator.progress-incomplete.progress-60 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-60);
  stroke: var(--lds-color-progress-indicator-circle-progress-60);
}
.lds-progress-indicator.progress-incomplete.progress-70 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-70);
  stroke: var(--lds-color-progress-indicator-circle-progress-70);
}
.lds-progress-indicator.progress-incomplete.progress-80 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-80);
  stroke: var(--lds-color-progress-indicator-circle-progress-80);
}
.lds-progress-indicator.progress-incomplete.progress-90 .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-90);
  stroke: var(--lds-color-progress-indicator-circle-progress-90);
}
.lds-progress-indicator.progress-complete .lds-progress-indicator-circle-progress {
  fill: var(--lds-color-progress-indicator-circle-fill-progress-complete);
  stroke: var(--lds-color-progress-indicator-circle-progress-complete);
}


.lds-progress-indicator-text {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  color: var(--lds-color-progress-indicator-text);
  text-align: center;
  transform: translateY(-50%) rotate(90deg);
  transition: color 1s;
  transform-origin: 50% 50%;
}
/* Allows the color of the text to change with every 10% change in the progress, if desired */
.lds-progress-indicator.progress-incomplete.progress-0 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-0);
}
.lds-progress-indicator.progress-incomplete.progress-10 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-10);
}
.lds-progress-indicator.progress-incomplete.progress-20 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-20);
}
.lds-progress-indicator.progress-incomplete.progress-30 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-30);
}
.lds-progress-indicator.progress-incomplete.progress-40 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-40);
}
.lds-progress-indicator.progress-incomplete.progress-50 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-50);
}
.lds-progress-indicator.progress-incomplete.progress-60 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-60);
}
.lds-progress-indicator.progress-incomplete.progress-70 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-70);
}
.lds-progress-indicator.progress-incomplete.progress-80 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-80);
}
.lds-progress-indicator.progress-incomplete.progress-90 .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-90);
}
.lds-progress-indicator.progress-complete .lds-progress-indicator-text {
  color: var(--lds-color-progress-indicator-text-complete);
}
`;

export default ProgressIndicatorStyle;
